module.exports = __webpack_public_path__ + "static/img/y5.dc0cc9b2.jpg";